import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Empty } from "./ui.js";
export function DataTable({ columns, rows, rowKey, empty, onRowClick, footnote, }) {
    if (!rows.length) {
        return _jsx(_Fragment, { children: empty ?? _jsx(Empty, { title: "\u6682\u65E0\u8BB0\u5F55", detail: "\u8BE5\u67E5\u8BE2\u6761\u4EF6\u6CA1\u6709\u8FD4\u56DE\u4EFB\u4F55\u6570\u636E\u3002" }) });
    }
    return (_jsxs("div", { className: "table-wrap", children: [_jsxs("table", { className: "table", children: [_jsx("thead", { children: _jsx("tr", { children: columns.map((c) => (_jsx("th", { className: c.align === "right" ? "is-num" : undefined, style: c.width ? { width: c.width } : undefined, children: c.label }, c.key))) }) }), _jsx("tbody", { children: rows.map((row, i) => (_jsx("tr", { onClick: onRowClick ? () => onRowClick(row) : undefined, style: onRowClick ? { cursor: "pointer" } : undefined, children: columns.map((c) => (_jsx("td", { className: [c.align === "right" ? "is-num" : "", c.mono ? "is-key" : ""].filter(Boolean).join(" ") || undefined, children: c.render ? c.render(row) : renderScalar(row[c.key]) }, c.key))) }, rowKey(row, i)))) })] }), footnote ? _jsx("div", { className: "muted", style: { padding: "10px 16px", fontSize: 12 }, children: footnote }) : null] }));
}
function renderScalar(v) {
    if (v === null || v === undefined || v === "")
        return _jsx("span", { className: "muted", children: "\u2014" });
    if (typeof v === "boolean")
        return v ? "true" : "false";
    if (typeof v === "object")
        return _jsx("span", { className: "muted", children: Array.isArray(v) ? `[${v.length}]` : "{…}" });
    const s = String(v);
    return s.length > 60 ? _jsxs("span", { title: s, children: [s.slice(0, 57), "\u2026"] }) : s;
}
/** Derive columns from the first row; used when a response shape is not worth pinning. */
export function autoColumns(rows, opts = {}) {
    const exclude = new Set(opts.exclude ?? []);
    const first = (rows[0] ?? {});
    return Object.keys(first)
        .filter((k) => !exclude.has(k))
        .slice(0, opts.max ?? 8)
        .map((k) => ({
        key: k,
        label: k.replace(/_/g, " "),
        align: /amount|total|price|quantity|count|_at$/.test(k) ? undefined : undefined,
        mono: /_id$|^id$/.test(k),
    }));
}
